import { useState } from "react";
import { Card, Group, Text, ActionIcon, Badge } from "@mantine/core";
import { IconEdit, IconTrash } from "@tabler/icons-react";
import { useDeleteRegistrationTicketType } from "../../api/registrationTicketTypes";
import { useDeleteConfirm } from "../../hooks/useDeleteConfirm";
import EditTicketTypeModal from "./EditTicketTypeModal";

function TicketTypeCard({ data, event }) {
  const [editModalOpened, setEditModalOpened] = useState(false);
  const { mutate } = useDeleteRegistrationTicketType(data.id);
  const confirmDelete = useDeleteConfirm("ticket type", mutate);

  return (
    <>
      <Card shadow="sm" p="md" radius="md" withBorder>
        <Group gap="sm" wrap="nowrap" align="center">
          <div style={{ flex: 1, minWidth: 0 }}>
            <Group gap="xs" wrap="wrap">
              <Text fw={600} size="sm" style={{ wordBreak: "break-word" }}>
                {data.name}
              </Text>
              {data.price && (
                <Badge size="sm" color="green" variant="light">
                  {data.price}
                </Badge>
              )}
            </Group>
            {data.description && (
              <Text size="xs" c="dimmed" mt={4} lineClamp={1}>
                {data.description}
              </Text>
            )}
          </div>

          <Group gap="xs" wrap="nowrap">
            <ActionIcon
              color="blue"
              onClick={() => setEditModalOpened(true)}
              variant="light"
              size="md"
            >
              <IconEdit size={20} />
            </ActionIcon>

            <ActionIcon
              color="red"
              onClick={() => confirmDelete()}
              variant="light"
              size="md"
            >
              <IconTrash size={20} />
            </ActionIcon>
          </Group>
        </Group>
      </Card>

      <EditTicketTypeModal
        opened={editModalOpened}
        onClose={() => setEditModalOpened(false)}
        data={data}
        event={event}
      />
    </>
  );
}

export default TicketTypeCard;
